<template>
  <div>
    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/landing/logo_black.png" searchImgSrc="../../../../static/img/landing/search_black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">
          <header class="company-PageTitle">
            <div class="company-PageTitle_Inner">
              <h1 data-appear="" class="company-PageTitle_Inner_Title">
                <span class="company-PageTitle_Logo"><b>COMPANY</b></span>
                <span class="company-PageTitle_Title"><b>企業情報</b></span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target">
                        <div class="company-PageTitle_Slide">
                          <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../../static/img/landing/childpageimg1.png) 20%/cover no-repeat;"></div>
                          <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../../static/img/landing/childpageimg1.png) 20%/cover no-repeat;"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="company-Profile">
            <div class="company-Profile_Inner">
              <h3 class="sw-Section_HeaderS" data-appear="">
                <span class="sw-Section_HeaderS-en"><b>COMPANY PROFILE</b></span>
                <span class="sw-Section_HeaderS-ja"><b>会社概要</b></span>
              </h3>
              <div class="company-Profile_List" data-appear="">
                <dl>
                  <dt>会社名</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <a href="/">
                        <p class="company-Profile_List-text">ナイスセラ株式会社 </p>
                      </a>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>代表者</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <a href="/">
                        <p class="company-Profile_List-text">小山 雄</p>
                      </a>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>設立</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">平成29年12月 <br class="sp"></p>
                    </div>
                  </dd>
                </dl>
                <dl class="location">
                  <dt>本社/営業所所在地</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <div class="company-Profile_List-label" style="">ナイスセラ株式会社(日本本部)</div>
                      <div class="company-Profile_List-text">〒436-0016 掛川市板沢1945番地の11<br />
                        TEL:0537-54-3336 <br />FAX:0537-54-3337
                      </div>
                      <br/>
                      <a href="http://www.simso-precision.com"><div class="company-Profile_List-label" style="">上海心尚精密机械有限公司（営業所）</div></a>
                      <div class="company-Profile_List-text">中国上海市宝山区城银路525弄绿地领创国际20楼2011室<br />
                        TEL:021-6083102 <br />FAX:021-6083103
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="location">
                  <dt>工場所在地</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <a href="http://www.simso-precision.com"><div class="company-Profile_List-label" style="">嘉兴市耐思威精密机械有限公司（工場）</div></a>
                      <div class="company-Profile_List-text">浙江省嘉兴市秀洲区高照街道康和路500号B12<br />
                        TEL:(86)573-8205-8763 <br />FAX:(86)573-8205-9363
                      </div>
                      <br/>
                      <a href="http://www.dglangdi.cn"><div class="company-Profile_List-label" style="">中国东莞市长安朗迪精密五金制品(工場)</div></a>
                      <div class="company-Profile_List-text">东莞市长安镇厦边上朗路6号<br />
                      TEL:18929295480 <br />Email:ceo@dglangdi.cn
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="business">
                  <dt>グループ会社</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <a href="http://rbb.co.jp/"><div class="company-Profile_List-label mt-5" style="">RBB株式会社</div></a>
                      <div class="company-Profile_List-text">〒409-3822 山梨県中央市下三條605-2<br />
                      TEL:055-215-8289 <br />FAX:055-207-3790
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="business">
                  <dt>事業内容</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text"><span>精密部品加工/委託材料加工/ステンレス製品/アルミ合金製品/高性能のプラスチック製品/純チタン製品/チタン合金製品/高硬度材先端セラミック製品/高純度単結晶シリコン製品/炭化ケイ素製品</span></p>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </section>
          <!-- ▲▲▲▲▲ contents end ▲▲▲▲▲ -->

        </main><!-- /.st-MainContents -->
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="https://schema.org/BreadcrumbList">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="https://schema.org/ListItem">
              <a class="st-BreadcrumbsList_Item-link" href="/">
                <p itemprop="item" aria-current="page"><span itemprop="name">ホーム</span></p>
              </a>
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="https://schema.org/ListItem">
              <p itemprop="item" aria-current="page"><span itemprop="name">企業情報</span></p>
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
      $('.company-Message_Inner').eq(0).addClass('appear')
      $('.sw-Section_HeaderS').eq(0).addClass('appear')
      // element.offsetHeight
      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        console.log(scroH)
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH >= 300) {
            $('.company-PageTitle_Inner_Title').eq(0).removeClass('appear')
          } else {
            $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
          }
          if (scroH >= 700) {
            $('.sw-Section_HeaderS').eq(0).removeClass('appear')
          } else {
            $('.sw-Section_HeaderS').eq(0).addClass('appear')
          }
          if (scroH >= 100) {
            $('.company-Profile_List').eq(0).addClass('appear')
          } else {
            $('.company-Profile_List').eq(0).removeClass('appear')
          }
        } else {
          $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
          $('.company-Message_Inner').eq(0).addClass('appear')
          $('.company-Message_Movie').eq(0).addClass('appear')
          $('.sw-Section_HeaderS').eq(0).addClass('appear')
          $('.company-Group_Text').eq(0).addClass('appear')
          $('.company-Group_Flow').eq(0).addClass('appear')
          $('.company-Group_List-column').eq(0).addClass('appear')
          $('.company-Group_List-column').eq(1).addClass('appear')
          $('.company-Group_List-column').eq(2).addClass('appear')
          $('.company-Group_List-column').eq(3).addClass('appear')
          $('.sw-Section_HeaderS').eq(1).addClass('appear')
          $('.company-Profile_List').eq(0).addClass('appear')
        }

        // appear
      })
    }
  }
}
</script>
<style scoped>
dd {
    margin-bottom: 0rem;
    margin-left: 0;
}
 a {
    border-bottom-style: none;
  }
  .home>>>.st-Nav_List-en {
    color: #222;
  }

  .home>>> .st-Nav_List-ja {
    color: #222;
  }

  .home>>> .st-Header {
    background-color: #fff;
    border-bottom: 1px solid #ddd;

  }

  .home>>>.company font {
    color: #c7000b
  }

  .home>>>.company:after {
    transform: scaleX(1) !important;
  }

  @media screen and (min-width: 769px) {

    .company-Profile_List-label{
      width: 38%;text-align: center;
    }
  }

  @media screen and (max-width: 769px) {

    .company-PageTitle{
      padding-top: 0px !important;
      margin-top: -5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/company/company.vue